/** DEV OPTS*/
/* @flow */

/* eslint-env node*/
/* eslint-disable no-console */
/*
 * Coach Amigo React Hybrid App module
 * https://github.com/facebook/react-native
 * @version 1.0.0
 */
import type { Props } from './../types/types';

import * as React from 'react';
import { View, Text, Touchable } from '../../../src/App/libs/WebComponents';
import { DEV } from '../../../src/App/Constants';
import { getColor } from '../utils/Colors';
import * as Icons from './../icons/index';

const Icon = (props: Props) => {
   if (!props) props = {};
   props = {
      color: getColor.rgb('$blue'),
      type: 'custom',
      size: props.size ? (typeof props.size === 'string' ? parseInt(props.size.replace('rem', '')) : props.size) : 56,
      name: 'Number-?',
      onPress: null,
      iconStyle: {},
      className: null,
      style: {},
      ...props
   };

   let className = '';

   if (props.className) className = className + ' ' + props.className;

   if (props.name && props.name.substr(0, 7) === 'Number-') {
      return (
         <View className={'view icon'} style={{ width: props.size, height: props.size, alignItems: 'center', justifyContent: 'center', borderRadius: props.size / 2 }}>
            <Text
               className={className}
               style={{
                  userSelect: 'none',
                  alignSelf: 'center',
                  minWidth: props.size * 1.3,
                  textAlign: 'center',
                  fontWeight: 'bold',
                  color: props.color,
                  lineHeight: props.size * 2,
                  fontSize: !props.iconSize ? props.size : props.iconSize,
                  ...props.iconStyle
               }}
            >
               {props.name.replace('Number-', '')}
            </Text>
         </View>
      );
   }

   let CustomIcon = props.name && Icons[props.name] ? Icons[props.name] : null;
   if (!CustomIcon) {
      if (DEV) console.warn('missing icon: ', props.name);
      CustomIcon = Icons['Minus'];

      props.style = { ...props.style, backgroundColor: getColor.rgb('$red') };
      props.color = getColor.rgb('$white');
   }

   const IconView = <CustomIcon style={props.iconStyle} className={className} viewBox={'0 0 56 56'} width={props.size} height={props.size} fill={props.color ? props.color : getColor.rgb('$black')} />;

   if (props.onPress)
   {
      return <Touchable style={props.style} onPress={props.onPress}>{IconView}</Touchable>

   }
   return (
      <View className={'view icon'} style={props.style}>{IconView}</View>
   );
};

export default React.memo(Icon);
